(() => {
  const initFaqPage = (root = document) => {
    root.querySelectorAll("[data-olmo-faq-page]").forEach((page) => {
      if (page.dataset.olmoFaqInit === "true") return;
      page.dataset.olmoFaqInit = "true";

      const search = page.querySelector("[data-olmo-faq-search]");
      const items = Array.from(page.querySelectorAll("[data-olmo-faq-item]"));
      const noResults = page.querySelector("[data-olmo-faq-no-results]");

      const normalize = (value) => String(value || "").toLowerCase().trim();

      const updateSearch = () => {
        if (!search) return;

        const query = normalize(search.value);
        let visibleCount = 0;

        items.forEach((item) => {
          const text = normalize(item.textContent);
          const isMatch = !query || text.includes(query);

          item.hidden = !isMatch;

          if (isMatch) visibleCount += 1;

          if (!query) {
            item.open = item.dataset.defaultOpen === "true";
          }
        });

        if (query) {
          const firstVisible = items.find((item) => !item.hidden);
          items.forEach((item) => {
            item.open = item === firstVisible;
          });
        }

        if (noResults) {
          noResults.classList.toggle("is-visible", visibleCount === 0);
        }
      };

      if (search) {
        search.addEventListener("input", updateSearch);
      }

      items.forEach((item) => {
        item.addEventListener("toggle", () => {
          if (!item.open) return;

          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });

      updateSearch();
    });
  };

  const boot = (event) => {
    initFaqPage(event && event.target ? event.target : document);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();